import '@fontsource/inter/latin-300.css'
import type { Me } from '../types.ts'
import { AppMark } from '../ui.tsx'

/** Good morning, afternoon or evening, by the viewer's own clock. */
function greeting(now = new Date()): string {
  const hour = now.getHours()
  if (hour >= 5 && hour < 12) return 'Good morning'
  if (hour >= 12 && hour < 17) return 'Good afternoon'
  return 'Good evening'
}

/** The apps the company has and the person may use, as a home screen of icons (PLAN.md
 *  1.6). Each opens the app, which signs them in through ICE without asking again. MCP servers
 *  aren't apps: they're under Settings › MCP servers. */
export function Home({ me }: { me: Me }) {
  const current = me.current!
  const first = current.person.displayName.split(' ')[0]
  const { apps } = current
  return (
    <section className="home">
      <h1 className="hello">{greeting()}, {first}</h1>
      {apps.length === 0 ? (
        <p className="muted center">You don't have access to any apps yet. Ask your company's administrator.</p>
      ) : (
        <>
          {apps.length > 0 && (
            <ul className="springboard">
              {apps.map((app) => (
                <li key={app.appId}>
                  {app.url ? (
                    <a className="app-icon" href={app.url}>
                      <AppMark appId={app.appId} name={app.name} size={128} />
                      <span className="app-icon-name">{app.name}</span>
                    </a>
                  ) : (
                    <span className="app-icon app-icon-off" title={`${app.name} isn't available yet`}>
                      <AppMark appId={app.appId} name={app.name} size={128} />
                      <span className="app-icon-name">{app.name}</span>
                    </span>
                  )}
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </section>
  )
}
